import onEnvironmentChange from '@/observables/environment.observable'
import { apm, init as initApm } from '@elastic/apm-rum'
import type Environment from '@interfaces/environment.interface'
import { take } from 'rxjs/operators'
import UserHelper from './user.helper'

export default class LogHelper {
  constructor() {
    onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
      initApm({
        environment: environment?.env,
        serviceName: 'web-hub-main',
        serverUrl: environment?.apmUrl,
      })
    })
  }
  async setUserContext() {
    const userHelper = new UserHelper()
    const user = await userHelper?.getUserObject()
    const userContext = {
      id: user?.userInfo?.squidId,
      username: user?.userInfo?.profileadditionalinfo?.name,
      email: user?.userInfo?.profileadditionalinfo?.email,
    }
    apm.setUserContext(userContext)
  }

  async setCustomContext(message, component) {
    const userAgent = window.navigator.userAgent
    const context = {
      user_agent: userAgent,
      user_id: '',
      stack: message.error || message.message,
      component: component,
      http_status_code: '',
    }
    apm.setCustomContext(context)
  }

  async handleLogApm(log: any, component: string): Promise<any> {
    const transaction = apm.startTransaction(component, 'Error')

    const url = window.location.href
    const httpSpan = transaction.startSpan(url)
    await this.setUserContext()
    await this.setCustomContext(log, component)
    apm.captureError(new Error(`${component} | ${log.message}`))
    httpSpan?.end()
    transaction?.end()
  }
}
